import { Context } from "./Context";
export class ExtentContext extends Context {
    constructor(layer, map) {
        super(map);
        this.name = 'extentbase';
        this.layer = layer;
        this.extent = [0, 0, 0, 0];
    }
    conflate_extents(acc, next) {
        return [
            Math.min(acc[0], next[0]),
            Math.min(acc[1], next[1]),
            Math.max(acc[2], next[2]),
            Math.max(acc[3], next[3])
        ];
    }
    get_bounding_extent() {
        return this.layer.features
            .map(f => { var _a; return (_a = f.getGeometry()) === null || _a === void 0 ? void 0 : _a.getExtent(); })
            .filter(ext => typeof ext !== "undefined")
            .reduce((acc, next) => this.conflate_extents(acc, next), [Infinity, Infinity, -Infinity, -Infinity]);
    }
    set_extent() {
        this.extent = this.get_bounding_extent();
    }
    on_enter() {
        this.set_extent();
    }
    zoom(_force) {
        this.set_extent();
        this.view.fit(this.extent, { padding: [120, 80, 120, 80], duration: 200 });
    }
}
